/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2021, Zumper
 * @description App banner to use in homepage and maplist
 */

import { Box, Button, Flex, Link } from '@chakra-ui/react'
import { Zumper } from '@zcode-ui/icons'
import { rootRelative } from '@zcode/utils'
import * as React from 'react'
import { Ratings } from '../Ratings/Ratings'
import { HEADLINE, NOT_NOW, USE_THE_APP } from '../constants'
import type { Props } from '../types'

export const AppBanner = React.memo(function AppBanner({ handleClose, isHidden, url }: Props) {
  return (
    <Flex
      alignItems="center"
      bgColor="blue.900"
      bottom={0}
      display={isHidden ? 'none' : undefined}
      flexDirection="column"
      height="132px"
      justifyContent="space-around"
      paddingX={6}
      paddingY={4}
      position="fixed"
      sx={{
        '@media (max-width: 320px)': {
          paddingX: 4,
        },
      }}
      width="full"
      zIndex="sticky"
    >
      <Flex alignItems="center" height="50%" width="full">
        <Flex
          alignItems="center"
          backgroundColor="gray.0"
          borderRadius="lg"
          height={10}
          justifyContent="center"
          marginRight={4}
          width={10}
        >
          <Zumper />
        </Flex>
        <Flex color="gray.0" flexDirection="column" fontSize="md" fontWeight="bold" lineHeight={6}>
          <Box<'div'>>{HEADLINE}</Box>
          <Ratings fill="#FFFFFF" size={12} withAmount />
        </Flex>
      </Flex>
      <Flex alignItems="flex-end" height="50%" justifyContent="flex-end" width="full">
        <Button
          color="gray.0"
          fontSize="sm"
          fontWeight="bold"
          height={8}
          letterSpacing="-0.2px"
          onClick={() => handleClose()}
          paddingX={4}
          paddingY={1.5}
          variant="ghost"
          width="88px"
        >
          {NOT_NOW}
        </Button>
        <Link
          backgroundColor="gray.0"
          borderRadius="120px"
          color="gray.950"
          fontSize="sm"
          fontWeight="bold"
          height={8}
          href={rootRelative(url)}
          letterSpacing="-0.2px"
          marginLeft={2}
          paddingX={4}
          paddingY={1.5}
          textDecoration="none"
        >
          {USE_THE_APP}
        </Link>
      </Flex>
    </Flex>
  )
})
